/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import {
  makeStyles,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from '@material-ui/core'

import { Alert, Pagination } from '@material-ui/lab'
import { ReactComponent as SearchIcon } from '@assets/images/svg/search.svg'
import CopyClipBoard from '@components/CopyClipBoard'
import { resellerApiWithToken } from '@api/baseApi'
import getDomain from '@config/domain'
// import { getCollectionApi } from './api'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.5rem 2rem',
    background: '#fff',
    borderRadius: 10,
    marginBottom: '2rem',
    '& p': {
      fontWeight: 600,
      lineHeight: '27px',
    },
  },
  table: {
    marginTop: '0.625rem',
    paddingBottom: '2rem',
  },
  percentage: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  searchField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
      width: '350px',
    },
    '& .MuiInputAdornment-positionStart': {
      paddingBottom: 0,
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  dateField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
      width: 170,
      marginRight: '1rem',
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  filterForm: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '1rem',
  },
  loading: {
    padding: '1rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  resetButton: {
    fontSize: '0.875rem',
    height: 38,
  },
}))

const TableProducts = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [products, setProducts] = useState()
  const [params, setParams] = useState({
    page: 1,
    per_page: 10,
    domain: getDomain(),
  })
  const affiliateCode = JSON.parse(localStorage.getItem('payload'))?.affiliate_code || JSON.parse(localStorage.getItem('payload'))?.no_member || ''

  const scope = Cookies.get('scope')
  let paramLink
  let path

  if (scope === 'reseller') {
    paramLink = `ref=${affiliateCode}`
    path = '/resellers/products'
  } else {
    paramLink = `aff=${affiliateCode}`
    path = '/affiliates/products'
  }

  const fetchProduct = async () => {
    try {
      setLoading(true)
      const { status, data } = await resellerApiWithToken.get(path, { params })

      if (status === 200) {
        setProducts(data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const resetFilter = () => {
    setParams({
      page: 1,
      per_page: 10,
      domain: getDomain(),
    })
  }

  useEffect(() => {
    fetchProduct()
  }, [params])

  return (
    <div className={classes.root}>
      <p>Produk</p>
      <div className={classes.filterForm}>
        <TextField
          placeholder="Cari nama produk"
          value={params.name || ''}
          onChange={(e) => setParams({ ...params, name: e.target.value })}
          className={classes.searchField}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
          }}
          variant="outlined"
        />
        <div>
          <Button
            color="primary"
            variant="contained"
            className={classes.resetButton}
            onClick={() => resetFilter()}
          >
            Reset
          </Button>
          {/* </MuiPickersUtilsProvider> */}
        </div>
      </div>
      {!loading ? (
        <Fragment>
          {products && products.data?.length > 0 ? (
            <Fragment>
              <TableContainer className={classes.table}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Nama</TableCell>
                      <TableCell>Kategori</TableCell>
                      <TableCell>Harga</TableCell>
                      <TableCell>Gambar Pada</TableCell>
                      <TableCell>Link</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.data.map((product, index) => (
                      <TableRow key={product.id}>
                        <TableCell>{(((params.page - 1) * 10) + (index + 1))}</TableCell>
                        <TableCell>{product.name}</TableCell>
                        <TableCell>{product.category || product.category_name}</TableCell>
                        <TableCell>{product.formatted_price || product.price}</TableCell>
                        <TableCell>
                          <img src={product?.image_thumbnail || 'https://via.placeholder.com/64'} alt={product.name} height={64} width={64} />
                        </TableCell>
                        <TableCell>
                          <CopyClipBoard link={`${product.link}?${paramLink}`} />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                count={products.pagination.total_pages}
                page={params.page}
                onChange={(_event, value) => setParams({ ...params, page: value })}
                shape="rounded"
              />
            </Fragment>
          ) : (
            <Alert variant="outlined" severity="warning">
              Data yang di cari masih kosong / tidak ditemukan
            </Alert>
          )}
        </Fragment>
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}
    </div>
  )
}

export default TableProducts
